<template>
  <div class="main">
    <div
      class="main__others"
      v-if="mapList.length>0"
    >
      <ul>
        <li
          style="width:20%"
          :title="'电芯'+`${index+1}`+'电压:'+item+'V'"
          v-for="(item, index) in mapList"
          :key="index"
        >
          <span class="title">电芯{{index + 1}}电压: </span>
          <span class="value">{{item}}{{type == 'LD-01A'?'mV':'V'}}</span>
        </li>
      </ul>
    </div>
    <div
      class="main__others"
      v-if="tempList.length>0">
      <ul>
        <li
          style="width:20%"
          :title="'电芯'+`${index+1}`+'温度:'+item+'℃'"
          v-for="(item, index) in tempList"
          :key="index"
        >
          <span class="title">电芯{{index+1}}温度: </span>
          <span class="value">{{item}}℃</span>
        </li>
      </ul>
    </div>
    <div
      class="main__others"
      v-if="salveTempList.length>0">
      <ul>
        <li
          style="width:20%"
          :title="'从控温度'+`${index+1}`+':'+item+'℃'"
          v-for="(item, index) in salveTempList"
          :key="index"
        >
          <span class="title">从控温度{{index+1}}: </span>
          <span class="value">{{item}}℃</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tempList: [],
      mapList:[]
    };
  },
  props: {
    data: {
      type: Object
    }
  },
  computed:{
    type(){
        return this.$store.state.activeCls;
    }
  },
  watch: {
    data: {
      handler(val) {
        if (!val) return;
        this.tempList = val.tempList || [];
        this.mapList = val.mapList || [];
        this.salveTempList = val.salveTempList || [];
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    
  }
};
</script>
<style lang="scss" scoped>
.main {
  &__others {
    padding: 10px 0;
    display: flex;
    flex: 1;
    border-bottom: 1px solid rgb(216, 217, 218);
    ul {
      display: flex;
      flex: 1;
      flex-direction: row;
      flex-wrap: wrap;
      li {
        width: 25%;
        padding: 10px 0;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .title {
          font-size: 14px;
          color: #999999;
        }
        .value {
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
}
</style>